export default class ReactNotificationService {
  notification = null;
  isReactNotificationModalOpen = false;

  onReactNotificationModalClose = () => {
    this.isReactNotificationModalOpen = false;
    this.notification = false;
  };

  openReactNotificationModal = (notification) => {
    this.isReactNotificationModalOpen = true;
    this.notification = notification;
  };
}
